import { atom } from "recoil";

export interface StudentState {
  id?: string;
  tel: string;
  name: string;
  birth: Date | undefined;
  gender: string;
  userId?: string;
  schoolId: string;
  password?: string;
  entityType: string;
  schoolType: string;
  questionAnswer: string;
  studentIdNumber: string;
  agreementTime1?: string;
  agreementTime2?: string;
  guardianAccExist: string;
  organizationName?: string;
  accountFindQuestion: string;
}

export interface GuardianState {
  id?: string;
  tel: string;
  name: string;
  birth: Date | undefined;
  userId?: string;
  password?: string;
  questionAnswer?: string;
  agreementTime1?: string;
  agreementTime2?: string;
  accountFindQuestion?: string;
}

export interface JoinCommState {
  userId: string;
  password: string;
  entityType: string;
  passwordCheck: string;
  questionAnswer: string;
  organizationName?: string;
  accountFindQuestion: string;
}

export interface GuardianExistState {
  guardianAccExist: string;
}

export const joinCommState = atom<JoinCommState>({
  key: "joinCommState",
  default: {
    userId: "",
    password: "",
    entityType: "",
    passwordCheck: "",
    questionAnswer: "",
    organizationName: "",
    accountFindQuestion: "",
  },
});
